const LISTING_TYPES = {
  RENTAL: 'For Rent',
  ROOM: 'Room for Rent',
  SALE: 'For Sale',
} as const;

const PROPERTY_TYPES = {
  COMMUNITY: 'Entire Apartment Community',
  CONDO: 'Condo / Apartment Unit',
  HOUSE: 'House',
  TOWNHOUSE: 'Townhouse',
} as const;

const { RENTAL, ROOM, SALE } = LISTING_TYPES;
const { COMMUNITY, CONDO, HOUSE, TOWNHOUSE } = PROPERTY_TYPES;

const PROPERTY_CODES_BY_TYPE = {
  [COMMUNITY]: 1,
  // not currently using these two
  // GARDEN: 2,
  // MEDIUM: 3,
  [CONDO]: 5,
  [HOUSE]: 6,
  [TOWNHOUSE]: 7,
} as const;

const LISTING_CODES_BY_TYPE = {
  [RENTAL]: 1,
  [SALE]: 2,
  [ROOM]: 5,
} as const;

const PROPERTY_TYPES_BY_CODE: Record<number, string> = {
  1: COMMUNITY,
  2: COMMUNITY,
  3: COMMUNITY,
  5: CONDO,
  6: HOUSE,
  7: TOWNHOUSE,
};

const LISTING_TYPES_BY_CODE = {
  1: RENTAL,
  2: SALE,
  5: ROOM,
};

const PropertyConstants = {
  PROPERTY_CODES_BY_TYPE,
  PROPERTY_TYPES,
  LISTING_TYPES,
  LISTING_CODES_BY_TYPE,
  PROPERTY_TYPES_BY_CODE,
  LISTING_TYPES_BY_CODE,
};

export type PropertyTypesValues = (typeof PROPERTY_TYPES)[keyof typeof PROPERTY_TYPES];

export { PropertyConstants };
